export default __webpack_public_path__ + "static/media/report.bdc5b3f0.png";